import React, { useMemo } from 'react';
import { Tabs } from '@adobe/react-spectrum';
import { DeepLinkContextProvider, useDeepLinkContext, useDeepLinkSegment } from './useDeepLinkSegment';

export function DeepLinkTabs({ defaultSelectedKey, onSelectionChange, children, ...rest }) {
    const { depth, defaults, path = [] } = useDeepLinkContext();
    const [selectedKey, setSelectedKey] = useDeepLinkSegment(defaultSelectedKey);

    const handleChange = (key) => {
        setSelectedKey(key);
        onSelectionChange?.(key);
    };

    // Push the currently-selected key onto the path so nested useDeepLinkParam
    // calls auto-scope under this tab (e.g. a `filter` inside the Salt tab
    // becomes `salt.filter` in the URL hash).
    const childContext = useMemo(
        () => ({
            depth: depth + 1,
            defaults: [...defaults, defaultSelectedKey],
            path: [...path, selectedKey],
        }),
        [depth, defaults, defaultSelectedKey, path, selectedKey]
    );

    return (
        <DeepLinkContextProvider value={childContext}>
            <Tabs
                {...rest}
                defaultSelectedKey={defaultSelectedKey}
                selectedKey={selectedKey}
                onSelectionChange={handleChange}
            >
                {children}
            </Tabs>
        </DeepLinkContextProvider>
    );
}
